<template>
<div>
    <div v-bind:class="className">
        <label class="control-label"> {{item.label}} </label>
        <input v-bind:id="item.name" v-bind:type="item.type" class="form-control margin-bottom" v-on:change="update" v-bind:placeholder="item.placeholder" v-bind:name="item.name" v-bind:disabled="item.disabled" multiple="multiple" style="display:none">
        <button v-if="!item.downloadOnly" v-on:click="click">Seleccionar archivos</button>
        <div v-for="error in item.errors" v-bind:class="{'margin-left': item.type=='checkbox'}" class="to-up" id="errors">
            {{ error }}
        </div>
    </div>
    <div class="clearfix"></div>
    <div v-if="item.value!==null && item.value.length>0" class="container-fluid table-responsive">
        <table class="table table-striped">
            <thead>
                <th>Nombre</th>
                <th v-if="!item.downloadOnly">Tamaño</th>
                <th>Tipo de adjunto</th>
                <th v-if="!item.downloadOnly">Progreso</th>
                <th v-if="!item.downloadOnly">Eliminar</th>
                <th v-if="item.downloadOnly">Descargar</th>
            </thead>
            <tbody>
                <tr v-for="file, key in item.value">
                    <td>{{file.name}}</td>
                    <td v-if="!item.downloadOnly">{{file.sizeMB}}</td>
                    <td>{{file.type}}</td>
                    <td v-if="!item.downloadOnly">
                        <div class="progress">
                            <div class="progress-bar progress-bar-success" role="progressbar" v-bind:style="{width: file.ready + '%'}">
                            </div>
                        </div>
                    </td>
                    <td v-if="!item.downloadOnly" v-on:click="remove(key)"><span class="glyphicon glyphicon-trash"></span></td>
                    <td v-if="item.downloadOnly"><a v-bind:href="file.link">enlace</a></td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="clearfix"></div>
    <div v-bind:class="className">
        <br>
        <h5 id="file-text">Este campo permite adjuntar varios archivos siempre y cuando la suma de todos no superen 20MB, se permitirán las siguientes extensiones: PDF, XLS, XLSX, DOC o DOCX.</h5>
    </div>
</div>
</template>

<script>
import swal from 'sweetalert2'

export default {
    name: 'emt-file',
    props: {
        item: Object,
        className: String
    },
    data: function () {
        return {
            totalSize: 0
        }
    },
    methods: {
        update: function (event) {
            var self = this
            var BYTES = 1000000 // 1048576
            for (var i = 0; i < event.target.files.length; i++) {
                event.target.files[i].sizeMB = Math.round((event.target.files[i].size / BYTES) * 100) / 100
                var errors = []
                if ((event.target.files[i].sizeMB + self.totalSize) > self.item.maximumSize) {
                    errors.push('El archivo que intenta cargar excede el peso permitido')
                }
                var fileExtension = event.target.files[i].name.split('.')[event.target.files[i].name.split('.').length - 1]
                if (self.item.extensions.indexOf(fileExtension.toUpperCase()) === -1) {
                    errors.push('La extensión del archivo ' + event.target.files[i].name + ' no es permitida.')
                }
                if (errors.length > 0) {
                    var errorMessage = errors.join('<br>- ')
                    errorMessage = '<div style="text-align: left">- ' + errorMessage + '</div>'
                    swal({
                        title: 'Favor validar',
                        text: errorMessage,
                        type: 'warning',
                        html: errorMessage,
                        confirmButtonText: 'Aceptar'
                    })
                    return
                }
                event.target.files[i].asBase64 = null
                event.target.files[i].ready = 0
                self.item.value.push(event.target.files[i])
                self.totalSize = self.totalSize + event.target.files[i].sizeMB
                self.getBase64(event.target.files[i], self.item.value.length - 1)
            }
        },
        remove: function (index) {
            var self = this
            self.item.value.splice(index, 1)
        },
        click: function (event) {
            var self = this
            document.getElementById(self.item.name).click()
        },
        getBase64: function (file, index) {
            var self = this
            var reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = function () {
                var item = self.item.value[index]
                item.asBase64 = reader.result
                item.ready = 100
                self.item.value.splice(index, 1, item)
                self.$emit('input', event.target.value)
            }
            reader.onerror = function (error) {
                swal({
                    title: error,
                    text: '',
                    type: 'danger',
                    confirmButtonText: 'Aceptar'
                })
            }
        }
    },
    mounted: function () {
        var self = this
        if (self.item.value === null) {
            self.item.value = []
        }
        self.item.extensions.forEach(function (element, index) {
            self.item.extensions.splice(index, 1, element.toUpperCase())
        }, this)
    }
}
</script>



// WEBPACK FOOTER //
// emt-file.vue?70bf8595